module.exports = "<div class=\"weui_panel_bd\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/panel/panel-body.vue
 ** module id = 152
 ** module chunks = 0
 **/